/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgEdit(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M19.94 2.69c-.364 0-.713.144-.97.401l-9.353 9.353-.647 2.586 2.586-.647 9.353-9.353a1.371 1.371 0 00-.97-2.34zm-2.031-.66a2.871 2.871 0 014.06 4.061l-9.5 9.5a.751.751 0 01-.348.197l-4 1a.75.75 0 01-.91-.91l1-4a.75.75 0 01.198-.348l9.5-9.5zM1.995 4.116a2.75 2.75 0 011.944-.805h7a.75.75 0 010 1.5h-7a1.25 1.25 0 00-1.25 1.25v14a1.25 1.25 0 001.25 1.25h14a1.25 1.25 0 001.25-1.25v-7a.75.75 0 011.5 0v7a2.75 2.75 0 01-2.75 2.75h-14a2.75 2.75 0 01-2.75-2.75v-14c0-.73.29-1.43.806-1.945z'
      />
    </svg>
  );
}

export default SvgEdit;
